type SpecialOfferParams = URLSearchParams | Record<string, string | number | null | undefined>;

function getRuntimeBasePath(): string | undefined {
  if (typeof process === "undefined") {
    return undefined;
  }

  return process.env.NEXT_PUBLIC_BASE_PATH;
}

export function normalizeMinitoolsBasePath(basePath = getRuntimeBasePath()): string {
  if (!basePath || basePath === "/") {
    return "";
  }

  const withLeadingSlash = basePath.startsWith("/") ? basePath : `/${basePath}`;
  return withLeadingSlash.endsWith("/") ? withLeadingSlash.slice(0, -1) : withLeadingSlash;
}

function toSearchParams(params: SpecialOfferParams): URLSearchParams {
  if (params instanceof URLSearchParams) {
    return params;
  }

  const searchParams = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value !== null && value !== undefined) {
      searchParams.set(key, String(value));
    }
  }

  return searchParams;
}

export function buildMinitoolsSpecialOfferPath(
  assessmentType: string | undefined,
  params: SpecialOfferParams,
  basePath?: string,
): string {
  const type = assessmentType || "unknown";
  const searchParams = toSearchParams(params);
  return `${normalizeMinitoolsBasePath(basePath)}/assessments/${encodeURIComponent(
    type,
  )}/special-offer?${searchParams.toString()}`;
}

export function buildMinitoolsSpecialOfferUrl(
  assessmentType: string | undefined,
  params: SpecialOfferParams,
  options: {
    origin?: string;
    basePath?: string;
  } = {},
): string {
  const origin = (options.origin || "https://www.lifehack.org").replace(/\/$/, "");
  return `${origin}${buildMinitoolsSpecialOfferPath(assessmentType, params, options.basePath ?? "/tools")}`;
}

export function buildMinitoolsReportOfferPath(
  assessmentType: string | undefined,
  params: SpecialOfferParams,
  basePath?: string,
): string {
  const type = assessmentType || "unknown";
  const searchParams = toSearchParams(params);
  return `${normalizeMinitoolsBasePath(basePath)}/assessments/${encodeURIComponent(
    type,
  )}/report-offer?${searchParams.toString()}`;
}

export function buildMinitoolsReportOfferUrl(
  assessmentType: string | undefined,
  params: SpecialOfferParams,
  options: {
    origin?: string;
    basePath?: string;
  } = {},
): string {
  const origin = (options.origin || "https://www.lifehack.org").replace(/\/$/, "");
  return `${origin}${buildMinitoolsReportOfferPath(assessmentType, params, options.basePath ?? "/tools")}`;
}
